import { render, staticRenderFns } from "./ReservationMonthOverview.vue?vue&type=template&id=a201a0f0&scoped=true&"
import script from "./ReservationMonthOverview.vue?vue&type=script&lang=js&"
export * from "./ReservationMonthOverview.vue?vue&type=script&lang=js&"
import style0 from "./ReservationMonthOverview.vue?vue&type=style&index=0&id=a201a0f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a201a0f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/wisseloord/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a201a0f0')) {
      api.createRecord('a201a0f0', component.options)
    } else {
      api.reload('a201a0f0', component.options)
    }
    module.hot.accept("./ReservationMonthOverview.vue?vue&type=template&id=a201a0f0&scoped=true&", function () {
      api.rerender('a201a0f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/ReservationMonthOverview.vue"
export default component.exports